<template>
  <div class="main mainT2">
    <div class="testT-section testT2">
      <div class="example-img img2">
        <img
          src="../../assets/imageTests/posture_souplesse_tronc.png"
          alt="image test 2"
          class="img-test2"
        />
      </div>
      <div class="bloc2">
        <div class="explication1 explication2">
          <p>Penchez vous en avant amenez vous mains le plus bas possible.</p>
          <ul>
            <li>Garder les jambes tendues</li>
            <li>Descendez progressivement sans À-coup</li>
          </ul>
          <p>Quand vous avez terminé sélectionner la bonne réponse</p>
        </div>
        <div class="response-portable response-responsive" >
          <ul class="test_response-portable" v-if="user.sexe == 'homme'">
            <li
              v-for="tab in infoM"
              :key="tab.title"
              :class="[result === tab.position ? 'active' : '']"
              :id="tab.position"
              v-on:click.prevent="send(tab.position)"
            >
              <button
                :id="tab.position"
                name="tab"
                :value="tab.position"
                :class="[{ selected: selected === tab.position }]"
                @click.prevent="selected = tab.position"
              >
                {{ tab.title }}
              </button>
            </li>
          </ul>
          <ul class="test_response-portable femme" v-if="user.sexe !== 'homme'">
            <li
              v-for="tab in infoF"
              :key="tab.title"
              :class="[result === tab.position ? 'active' : '']"
              :id="tab.position"
              v-on:click.prevent="send(tab.position)"
            >
              <button
                :id="tab.position"
                name="tab"
                :value="tab.position"
                :class="[{ selected: selected === tab.position }]"
                @click.prevent="selected = tab.position"
              >
                {{ tab.title }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="testT-section-portable">
      <div class="example-img-portable img2">
        <img
          src="../../assets/imageTests/posture_souplesse_tronc.png"
          alt="image test 2"
          class="img-test2 img2-portable"
        />
      </div>
      <div class="bloc2-portable">
        <div class="explication1 explication1-portable explication2.portable">
          <p>Penchez vous en avant amenez vous mains le plus bas possible.</p>
          <ul>
            <li>Garder les jambes tendues</li>
            <li>Descendez progressivement sans À-coup</li>
          </ul>
          <p>Quand vous avez terminé sélectionner la bonne réponse</p>
        </div>
      </div>
    </div>
    <div class="response-portable portableP" >
      <ul class="test_response-portable" v-if="user.sexe == 'homme'">
        <li
          v-for="tab in infoM"
          :key="tab.title"
          :class="[result === tab.position ? 'active' : '']"
          :id="tab.position"
          v-on:click.prevent="send(tab.position)"
        >
          <button
            :id="tab.position"
            name="tab"
            :value="tab.position"
            :class="[{ selected: selected === tab.position }]"
            @click.prevent="selected = tab.position"
          >
            {{ tab.title }}
          </button>
        </li>
      </ul>
      <ul class="test_response-portable" v-if="user.sexe !== 'homme'">
        <li
          v-for="tab in infoF"
          :key="tab.title"
          :class="[result === tab.position ? 'active' : '']"
          :id="tab.position"
          v-on:click.prevent="send(tab.position)"
        >
          <button
            :id="tab.position"
            name="tab"
            :value="tab.position"
            :class="[{ selected: selected === tab.position }]"
            @click.prevent="selected = tab.position"
          >
            {{ tab.title }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Test_2",
  data() {
    return {
      infoM: [
        { title: "Vous touchez le sol les doigts fermés", position: 5 },
        { title: "Le bout des doigts touche le sol", position: 4 },
        { title: "Le bout des doigts touche le dessus du pied", position: 3 },
        { title: "Le bout des doigts touche la cheville", position: 2 },
        { title: "Le bout des doigts touche le milieu du tibia", position: 1 }
      ],
      infoF: [
        { title: "Les paumes touchent le sol", position: 5 },
        { title: "Vous touchez le sol poings fermés", position: 4 },
        { title: "Le bout des doigts touche le sol", position: 3 },
        { title: "Le bout des doigts touche les chevilles", position: 2 },
        { title: "Le bout des doigts touche le bas du tibia", position: 1 }
      ],
      activetab: 3,
      result: "",
      user: JSON.parse(localStorage.user) || [],
      selected: null
    };
  },
  created() {
    if (typeof localStorage.user !== undefined) {
      this.user = JSON.parse(localStorage.user);
      if (this.user.liste_Metier !== [] && this.user.liste_Metier.length > 0) {
        this.tableau_profession = this.user.liste_Metier;
        console.log(this.user.liste_Metier.length);
      }
      //console.log(this.user);
    } else {
      console.log("var not exist");
    }
  },
  methods: {
    send(data) {
      this.result = data;
      localStorage.vive = data;
      this.$emit("choice2");
    }
  }
};
</script>

<style>
.tabcontent {
  height: auto;
}


</style>



// WEBPACK FOOTER //
// src/components/Test/Test_2.vue